import { Configuration, PopupRequest, BrowserCacheLocation, PublicClientApplication } from "@azure/msal-browser";

const clientId = import.meta.env.VITE_CLIENT_ID;
const authority = `https://${import.meta.env.VITE_TENANT_NAME}.b2clogin.com/${
  import.meta.env.VITE_TENANT_NAME
}.onmicrosoft.com/${import.meta.env.VITE_SIGNIN_SIGNUP_FLOW_NAME}`;
const knownAuthorities = [`${import.meta.env.VITE_TENANT_NAME}.b2clogin.com`];
const userReadScope = import.meta.env.VITE_USER_READ_SCOPE;

export const msalConfig: Configuration = {
  auth: {
    clientId: clientId,
    authority: authority,
    knownAuthorities: knownAuthorities,
    redirectUri: "/",
    postLogoutRedirectUri: "/",
  },
  cache: {
    cacheLocation: BrowserCacheLocation.SessionStorage,
  },
  system: {
    loggerOptions: {
      loggerCallback: () => {},
    },
  },
};

// Add here scopes for id token to be used at MS Identity Platform endpoints.
export const loginRequest: PopupRequest = {
  scopes: ["openid", "offline_access"],
  extraScopesToConsent: [userReadScope],
};

export const askAmiApiTokenRequest = {
  scopes: [userReadScope],
};

export const msalInstance = new PublicClientApplication(msalConfig);
